<div
  [formGroup]="notificationAttachmentForm"
  class="notification"
  *ngIf="notificationAttachmentForm"
>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <div class="vs-text-field">
        <label
          ><span class="star"></span>
          {{ 'orderCheckOut.orderAknowledge' | cxTranslate }}</label
        >
        <input
          formControlName="orderAckEmail"
          autocomplete="off"
          type="text"
          [ngClass]="
            notificationAttachmentForm.get('orderAckEmail').invalid &&
            isProceedToCheckout
              ? 'error'
              : ''
          "
          (change)="onorderAckEmail($event.target.value)"
          name="orderAckEmail"
          autocomplete="off"
        />

        <label
          #orderAckEmailError
          class="error"
          *ngIf="
            notificationAttachmentForm.get('orderAckEmail').invalid &&
            isProceedToCheckout
          "
        >
          {{ 'orderCheckOut.emailErrorLbl' | cxTranslate }}
        </label>
      </div>
    </div>
  <!--   Business requirement to remove invoiceEmail and shipNotificationEmail
    <div class="col-lg-4 col-md-4 col-sm-4">
      <div class="vs-text-field">
        <label
          ><span class="star"></span>
          {{ 'orderCheckOut.invoiceEmailLbl' | cxTranslate }}</label
        >
        <input
          formControlName="invoiceEmail"
          autocomplete="off"
          type="text"
          [ngClass]="
            notificationAttachmentForm.get('invoiceEmail').invalid &&
            isProceedToCheckout
              ? 'error'
              : ''
          "
          (change)="oninvoiceEmailUpdate($event.target.value)"
          name="invoiceEmail"
          autocomplete="off"
        />

        <label
          #invoiceEmailError
          class="error"
          *ngIf="
            notificationAttachmentForm.get('invoiceEmail').invalid &&
            isProceedToCheckout
          "
        >
          {{ 'orderCheckOut.emailErrorLbl' | cxTranslate }}
        </label>
      </div>
    </div> -->
<!--     <div class="col-lg-4 col-md-4 col-sm-4">
      <div class="vs-text-field">
        <label
          ><span class="star"></span>
          {{ 'orderCheckOut.shipNotiEmail' | cxTranslate }}</label
        >
        <input
          formControlName="shipNotificationEmail"
          autocomplete="off"
          [ngClass]="
            notificationAttachmentForm.get('shipNotificationEmail').invalid &&
            isProceedToCheckout
              ? 'error'
              : ''
          "
          type="text"
          (change)="onshipNotificationEmail($event.target.value)"
          name="shipNotificationEmail"
          autocomplete="off"
        />

        <label
          #shipNotificationEmailError
          class="error"
          *ngIf="
            notificationAttachmentForm.get('shipNotificationEmail').invalid &&
            isProceedToCheckout
          "
        >
          {{ 'orderCheckOut.emailErrorLbl' | cxTranslate }}
        </label>
      </div>
    </div> -->

    <div class="file-upload">
      <div class="row upload-all-files">
        <div>
          <h5 class="upload-section-text">
            {{ 'orderCheckOut.uploadOrder' | cxTranslate }}
          </h5>

          <div class="col-md-7">
            <div>
              <label
                class="custom-upload"
                [ngClass]="{ 'disabled-btn': disbledBtn }"
                for="demofile-notify"
              >
                <input
                  class="hidden upload-input"
                  multiple
                  id="demofile-notify"
                  type="file"
                  (change)="uploadNotifyFile($event)"
                />
                <i class="material-icons custom-upload-icon">backup</i>
                <span> {{ 'orderCheckOut.uploadFile' | cxTranslate }} </span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="row custom-file-format-width">
        <div class="col-md-12 custom-margin-bottom">
          <h5 class="upload-section-text custom-file-type-margin">
            {{ 'orderCheckOut.fileFormate' | cxTranslate }}
          </h5>
        </div>
      </div>

      <div id="hideFile" *ngIf="cartOrderReviewObj?.attachments">
        <div
          id="fileInfo"
          class="fileInfo-section mt-30"
          *ngFor="let file of cartOrderReviewObj?.attachments"
        >
          <i class="material-icons material-icons-custom">receipt</i>
          <span id="para11">{{ file?.realFileName }}</span>
          <span id="para22">{{ convertFileRetain(file.attachmentSizes) }}</span>

          <span
            id="close"
            class="closeId-img"
            (click)="closeFile($event, file.mediaCode)"
          >
            <i class="material-icons">close</i>
          </span>
        </div>
      </div>

      <div id="docInnerNotify" class="section-document">
        <div
          id="fileInfo-notify"
          #fileInfoNotify
          class="fileInfo-section col-md-12"
        ></div>
        <p
          class="section-document-document-details error-msg"
          id="fileMaxLenghtExceednotify"
          #fileMaxLenghtExceednotify
        ></p>
        <p
          id="fileSizeExceedNotify"
          #fileSizeExceedNotify
          class="section-document-document-details error-msg"
        ></p>
        <p
          id="fileTypeNotify"
          #fileTypeNotify
          class="section-document-document-details error-msg"
        ></p>
        <p
          id="fileDuplicateNotify"
          #fileDuplicateNotify
          class="section-document-document-details error-msg"
        ></p>
        <p
          id="filenameLengthNotify"
          #filenameLengthNotify
          class="section-document-document-details error-msg"
        ></p>
        <p
          id="filenameSpecialcharNotify"
          #filenameSpecialcharNotify
          class="section-document-document-details error-msg"
        ></p>
      </div>
    </div>
  </div>
  <div class="vs-checkbox upload-checkbox" *ngIf="showCheckbox">
    <input
      id="document-upload-check"
      type="checkbox"
      (click)="getCheckBoxStatus()"
      [(ngModel)]="fileUploadCheck"
      [ngModelOptions]="{ standalone: true }"
      name="document-upload-check"
    />
    <label class="confirmation-label" for="document-upload-check"
      >{{ 'orderCheckOut.confirmationLabel' | cxTranslate }}
    </label>
  </div>

  <div class="upload mt-3">
    <span>{{ 'orderCheckOut.csrReviewConfirmation' | cxTranslate }}</span>
    <div class="vs-radio-button mt-3">
      <input
        id="agree-radio"
        type="radio"
        [checked]="
          notificationAttachmentForm.controls.orderReview.value === true
            ? true
            : false
        "
        formControlName="orderReview"
        value="true"
        (change)="doOrderReview(true, undefinedVar)"
        name="orderReview"
      />
      <label
        for="agree-radio"
        (click)="doOrderReview(true, undefinedVar)"
        class="ml3"
      >
        {{ 'orderCheckOut.yesLbl' | cxTranslate }}
      </label>

      <input
        id="disagree-radio"
        type="radio"
        [checked]="
          notificationAttachmentForm.controls.orderReview.value === false
            ? true
            : false
        "
        formControlName="orderReview"
        value="false"
        (change)="doOrderReview(false, undefinedVar)"
        name="orderReview"
      />
      <label for="disagree-radio" (click)="doOrderReview(false, undefinedVar)">
        {{ 'orderCheckOut.noLbl' | cxTranslate }}
      </label>
    </div>
  </div>

  <div class="vs-text-area mt-3" *ngIf="csrReview">
    <label
      ><span class="star"></span>
      {{ 'orderCheckOut.csrReviewLbl' | cxTranslate }}</label
    >
    <textarea
      required
      [ngClass]="
        isProceedToCheckout && csrTextAreaErrorConditionCheck() ? 'error' : ''
      "
      formControlName="reasonForCsrReview"
      (change)="onreasonForCsrReview($event.target.value)"
      name="reasonForCsrReview"
      maxlength="255"
    ></textarea>

    <label
      #reasonForCsrReviewError
      class="error"
      *ngIf="isProceedToCheckout && csrTextAreaErrorConditionCheck()"
    >
      {{ 'orderCheckOut.csrReviewErrorLbl' | cxTranslate }}
    </label>
  </div>
</div>
